<section class="easymde-markdown-editor" [class.easymde-markdown-editor--dark]="isDarkMode" [class.easymde-markdown-editor--fullscreen]="isFullscreen">
  <header class="easymde-markdown-editor__toolbar">
    <p>Markdown 原始碼與即時預覽(easymde)</p>
    <span></span>
    <button type="button" (click)="toggleDarkMode()" aria-label="切換深色模式">{{ isDarkMode ? '淺色' : '深色' }}</button>
    <button type="button" (click)="toggleFullscreen()" aria-label="切換全螢幕">{{ isFullscreen ? '離開全螢幕' : '全螢幕' }}</button>
  </header>
  <textarea #editorElement [attr.aria-required]="isRequired"></textarea>
</section>
